// extracted by mini-css-extract-plugin
export const accountModuleCell = "SettingsPage__accountModuleCell__oOILj SettingsPage__gridCell__ze8lQ";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const contactModuleCell = "SettingsPage__contactModuleCell__zSJ-1 SettingsPage__gridCell__ze8lQ";
export const footerWrapper = "SettingsPage__footerWrapper__HTgxR";
export const gridCell = "SettingsPage__gridCell__ze8lQ";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const personalInfoGrid = "SettingsPage__personalInfoGrid__Uz+v4";
export const profileModuleCell = "SettingsPage__profileModuleCell__gWh38 SettingsPage__gridCell__ze8lQ";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const subscriptionModuleCell = "SettingsPage__subscriptionModuleCell__f6O7L SettingsPage__gridCell__ze8lQ";
export const version = "SettingsPage__version__jwbnl";